/**
 * Constantes para roles de usuários do sistema
 *
 * Centraliza todos os IDs de roles para evitar magic numbers
 * e facilitar manutenção futura.
 */

// Roles principais do sistema
export const USER_ROLES = {
  ADMIN: 1,
  MONITOR: 2,
  INSTRUTOR: 3,
  ALUNO: 4,
  GESTOR: 5,
  FINANCEIRO: 6,
  SUPORTE: 7,
  COMERCIAL: 8,
  DETRAN: 9
}

// Mapeamento de nomes para facilitar debugging
export const ROLE_NAMES = {
  [USER_ROLES.ADMIN]: 'Administrador',
  [USER_ROLES.MONITOR]: 'Monitoramento',
  [USER_ROLES.INSTRUTOR]: 'Instrutor',
  [USER_ROLES.ALUNO]: 'Aluno',
  [USER_ROLES.GESTOR]: 'Gestor',
  [USER_ROLES.FINANCEIRO]: 'Financeiro',
  [USER_ROLES.SUPORTE]: 'Suporte',
  [USER_ROLES.COMERCIAL]: 'Comercial',
  [USER_ROLES.DETRAN]: 'Detran'
}

// Grupos de permissões
export const PERMISSION_GROUPS = {
  // Usuários que podem acessar configurações administrativas
  ADMIN_ACCESS: [USER_ROLES.ADMIN, USER_ROLES.MONITOR],

  // Usuários que podem acessar painel Telegram
  TELEGRAM_ACCESS: [USER_ROLES.ADMIN, USER_ROLES.MONITOR],

  // Usuários que podem acessar monitoramento
  MONITORING_ACCESS: [USER_ROLES.ADMIN, USER_ROLES.MONITOR, USER_ROLES.SUPORTE],

  // Usuários que podem enviar notificações
  NOTIFICATION_SENDERS: [USER_ROLES.MONITOR],

  // Cadastro de veículos e emissão de LADV junto ao Detran (só em tenant de instrutor autônomo).
  INTEGRACAO_DETRAN_AUTONOMO: [USER_ROLES.ADMIN, USER_ROLES.GESTOR],

  // Monitoramento e suporte logam fora do tenant: associam veículos escolhendo o autônomo no modal
  ASSOCIAR_VEICULOS_AUTONOMOS: [USER_ROLES.MONITOR, USER_ROLES.SUPORTE]
}

// Helpers para verificação de permissões
export const hasRole = (userRole, allowedRoles) => {
  if (Array.isArray(allowedRoles)) {
    return allowedRoles.includes(parseInt(userRole))
  }
  return parseInt(userRole) === parseInt(allowedRoles)
}

export const canAccessTelegram = (userRole, userSchema = null) => {
  const hasValidRole = hasRole(userRole, PERMISSION_GROUPS.TELEGRAM_ACCESS)

  // Se não temos schema, só verifica o role
  if (!userSchema) {
    return hasValidRole
  }

  // Se temos schema, verifica se é interno do NovoCFC (teste ou public)
  const isInternalSchema = userSchema === 'teste' || userSchema === 'public'

  return hasValidRole && isInternalSchema
}

export const canSendNotifications = (userRole) => {
  return hasRole(userRole, PERMISSION_GROUPS.NOTIFICATION_SENDERS)
}

export const canAccessAdminConfig = (userRole) => {
  return hasRole(userRole, PERMISSION_GROUPS.ADMIN_ACCESS)
}

export const isSchemaAutonomo = (schema) => {
  return typeof schema === 'string' && schema.startsWith('autonomo_')
}

export const getRoleName = (roleId) => {
  return ROLE_NAMES[parseInt(roleId)] || 'Desconhecido'
}
